// extracted by mini-css-extract-plugin
export default {"back":"BackToPacksList_back__OMuvw"};